import { BaseRequest } from '@/network/requests/BaseRequest'
import { defect_level } from '@/interfaces/defect_level'
import { stringToBlob } from '@/util/stringToPlainTextBlob'

export const defectLevelRequest = BaseRequest.build<defect_level>('defect_level')

/**
 * 上传缺陷等级文件。
 * @param content 缺陷等级配置XML内容。
 * @param fileName 配置名称。
 * @param fileId 文件Id。
 */
export const uploadDefectLevelXML = async (content: string, fileName: string, fileId?: string | undefined) => {
	const contentType = 'text/plain'
	const blob = stringToBlob(content, fileName, contentType)

	//上传文件内容。
	var newFileId = await defectLevelRequest.uploadFile(blob, contentType, fileId)

	if (!fileId) {
		//记录缺陷等级。
		defectLevelRequest.upload({
			file_id: newFileId,
			name: fileName,
		})
	}

	return fileId
}

/**
 * 删除缺陷等级参数配置。
 * @param id
 * @param fileId
 */
export const deleteDefectLevel = (id, fileId) => {
	//先删除记录。
	var p1 = defectLevelRequest.deleteById(id)
	//再删除文件。
	var p2 = defectLevelRequest.deleteFileById(fileId)

	return Promise.all([p1, p2])
}

/**
 * 修改名称
 * @param fileId
 * @param name
 * @param existFileId
 */
export const EditFileFromContent = async (fileId: string, name: string, existFileId?: string | undefined) => {
	return defectLevelRequest.modifyById(fileId, { name: name })
}
